import CryptoJS from "crypto-js";
export default {
  encode (val) {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(val));
  },
  decode (val) {
    return CryptoJS.enc.Base64.parse(val).toString(CryptoJS.enc.Utf8);
  }
}